import { createAsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { a as privateQuery } from '../../requestsCollection-A0HzS4ai.js';
import { GetYmal } from '../../services/graphql/ymal/index.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-WYINLSKJ.js';
import 'lodash';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../cookies-VX_DpI1q.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-O6unZmFR.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';

const getYmal = createAsyncThunk('ymal/getYmal', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateQuery(apolloConfig(), {
            query: GetYmal,
        }, 'GetYmal');
        const errorMessage = get(errors, [0, 'message'], '');
        if (errorMessage) {
            return rejectWithValue({
                errorMessage,
            });
        }
        return data.getymal;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { getYmal };
//# sourceMappingURL=thunks.js.map
